import { type SupersetEmbeddedDashboardConfiguration, type SupersetAssetsDTO, type SupersetGuestToken } from "src/types/superset";

import axiosErrorHandler from "./apiError.handler";
import http from "./axios";

export async function fetchEmbeddingConfig(dashboardId: number): Promise<SupersetEmbeddedDashboardConfiguration> {
  try {
    const { data } = await http.get<SupersetEmbeddedDashboardConfiguration>(`/ExtendedAnalytics/${dashboardId}`);
    return data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while loading embedding config");
  }
}

export async function fetchAvailableDashboards(): Promise<SupersetAssetsDTO> {
  try {
    const { data } = await http.get<SupersetAssetsDTO>("/ExtendedAnalytics");
    return data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while loading extended analytics dashboards");
  }
}

export async function fetchGuestToken(dashboardId: number): Promise<SupersetGuestToken> {
  try {
    const { data } = await http.get<SupersetGuestToken>(`/ExtendedAnalytics/GuestToken/${dashboardId}`);
    return data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while loading embedding config");
  }
}

export async function invalidateCache(): Promise<void> {
  try {
    const { data } = await http.post("/ExtendedAnalytics/InvalidateCache");
    return data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while invalidate cache");
  }
}
